module.exports = __webpack_public_path__ + "static/media/rest5.d7d1d173.webp";